import { createFileRoute } from '@tanstack/react-router'

import { withRecordParam } from '@/components/kit/list/record-param'
import { withdrawalFilters } from '@/features/money/withdrawal-filters'
import { WithdrawalsList } from '@/features/money/withdrawals-list'

export const Route = createFileRoute('/_app/withdrawals')({
    validateSearch: withRecordParam(withdrawalFilters.parse, 'order'),
    component: WithdrawalsList,
    staticData: { crumb: 'Withdrawals' }
})
